import { Components, Theme } from '@mui/material'

export const MuiDialogTitle: Components<Omit<Theme, 'components'>>['MuiDialogTitle'] = {
  defaultProps: {},
  styleOverrides: {
    root: {
      fontWeight: 600,
      fontSize: 20,
      paddingBottom: 4,
    },
  },
}
